import type { IIconsVector } from 'shared/ui'
import { isCustomFieldKey } from 'entities/CustomField'

export const iconsMapping: Record<string, IIconsVector> = {
  tag: 'tag',
  first_name: 'user',
  last_name: 'user',
  number: 'phone',
  email: 'email',
  message_status: 'messageCircleChecked',
  opt_in: 'toggle',
  source: 'toggle',
  keyword: 'keywords',
  total_received_sms: 'pieChart',
  total_received_call: 'pieChart',
  shortcode: 'hash',
  segments: 'segment',
  hubspot: 'plug',
  'hubspot-lists': 'plug',
  status: 'circleDot',
  created_at: 'calendar',
  owner_id: 'userFilled',
  sent_at: 'calendarArrowRight',
  number_id: 'phone',
  'broadcasts.status': 'circleDot',
  'workflows.status': 'circleDot',
  'broadcasts.created_at': 'calendar',
  'broadcasts.owner_id': 'userFilled',
  'broadcasts.sent_at': 'calendarArrowRight',
  'broadcasts.number_id': 'phone',
  'broadcasts_recurring_settings.type': 'repeat',
  'broadcasts_recurring_settings.status': 'circleDot',
  'campaigns.status': 'circleDot',
  'campaigns.user_id': 'userFilled',
  contact_owner_email: 'userFilled',
}

const customFieldIconMapping: Record<string, IIconsVector> = {
  number: 'number',
  text: 'textInput2',
  url: 'link',
  date: 'calendar',
}

const dateTypes = ['updated_created', 'date_time']

export const getIcon = ({
  type,
  key,
  category,
}: {
  type?: string
  key: string
  category?: string
}): IIconsVector => {
  if (isCustomFieldKey(key) && type) {
    return customFieldIconMapping[type]
  }

  if (category === 'geo-location') {
    return 'makerPin'
  }

  if (category === 'phone-checker') {
    return 'check2'
  }

  if (type && dateTypes.includes(type)) {
    return 'calendar'
  }

  return iconsMapping[key]
}

export const airCallTooltip = 'MMS is not currently supported by Aircall'
export const MIN_COUNT_CHARTERS_FOR_SEARCH = 3
export const minSearchCountText = `Please enter ${MIN_COUNT_CHARTERS_FOR_SEARCH} or more characters`
